<template>
	<div class="material-assets-page">
		<div class="page-header">
			<div class="filter-section">
				<div class="status-filter" style="display: none;">
					<span class="filter-label">状态：</span>
					<el-select v-model="activeStatus" placeholder="请选择" class="status-select">
						<el-option v-for="status in statusFilters" :key="status.value" :label="status.label"
							:value="status.value"></el-option>
					</el-select>
				</div>
				<div class="filter-buttons">
					<el-button v-for="filter in filters" :key="filter.value"
						:type="activeFilter === filter.value ? 'primary' : 'default'"
						@click="activeFilter = filter.value">
						{{ filter.label }}
					</el-button>
				</div>
			</div>
			<div class="upload-area">
				<el-button size="small" type="primary" @click="uploadDialogVisible = true">
					<i class="el-icon-upload"></i> 上传资产
				</el-button>
			</div>
		</div>
		<div class="assets-grid">
			<div v-for="asset in filteredAssets" :key="asset.resourceId" class="asset-card"
				:class="{ selected: selectedIds.includes(asset.resourceId) }" @click="handleSelect(asset.resourceId)">
				<div class="asset-preview">
					<el-image v-if="asset.resourceCate === 1 || asset.resourceCate === 3" :src="asset.resourceUrl"
						fit="cover" @mouseenter="handlePreview(asset.resourceUrl)" @mouseleave="handlePreviewLeave">
						<div class="asset-overlay">
							<el-button size="mini" type="danger" @click.stop="handleDelete(asset.resourceId)">
								<i class="el-icon-delete"></i> 删除
							</el-button>
						</div>
					</el-image>
					<div v-else-if="asset.resourceCate === 4" class="video-preview">
						<video :src="asset.resourceUrl" controls />
					</div>
					<div v-else class="audio-preview">
						<audio :src="asset.resourceUrl" controls />
					</div>
					<span v-if="asset.resourceCate === 2" class="audio-badge">音频</span>
					<span v-if="asset.resourceCate === 3" class="scene-badge">场景</span>
					<span v-if="asset.resourceCate === 4" class="video-badge">视频</span>
				</div>
				<div class="asset-info">
					<p class="asset-name">{{ asset.resourceName }}</p>
				</div>
			</div>
		</div>
		<div v-if="selectedIds.length > 0" class="batch-actions">
			<span>已选择 {{ selectedIds.length }} 个文件</span>
			<el-button type="danger" @click="handleBatchDelete">
				<i class="el-icon-delete"></i> 批量删除
			</el-button>
		</div>
		<div class="pagination-area">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="pageNum" :page-sizes="[20, 50, 100]" :page-size="pageCount"
				:total="total" layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</div>
		<el-dialog :visible.sync="uploadDialogVisible" title="上传资产" width="500px">
			<el-form :model="uploadForm" label-width="100px">
				<el-form-item label="资产名称">
					<el-input v-model="uploadForm.resourceName" maxlength="50" placeholder="请输入资产名称"></el-input>
				</el-form-item>
				<el-form-item label="是否公开">
					<el-switch v-model="uploadForm.resourceType" active-text="公开" inactive-text="私有"></el-switch>
				</el-form-item>
				<el-form-item label="资产类型">
					<el-radio-group v-model="uploadForm.resourceCate">
						<el-radio label="image">形象</el-radio>
						<el-radio label="audio">音频</el-radio>
						<el-radio label="scene">场景</el-radio>
						<el-radio label="video">视频</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="素材性别">
					<el-radio-group v-model="uploadForm.resourceGender">
						<el-radio label="male">男</el-radio>
						<el-radio label="female">女</el-radio>
						<el-radio label="other">其他</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="素材上传">
					<el-upload :action="`${BASE_URL}/resource/upload?token=${this.adminInfo.adminToken}`" :accept="getAcceptType()" :show-file-list="true"
						:file-list="uploadFileList" :on-success="handleFileUploadSuccess" :on-change="handleFileChange"
						:auto-upload="false" :limit="1" :on-exceed="handleExceed">
						<el-button size="small" type="primary">选择文件</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item label="素材备注">
					<el-input v-model="uploadForm.resourceRemark" type="textarea" placeholder="请输入备注信息"
						:rows="3"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="uploadDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="handleSubmitAsset">确定上传</el-button>
			</div>
		</el-dialog>
		<div v-if="previewVisible" class="custom-preview"
			:style="{ left: previewPosition.x + 'px', top: previewPosition.y + 'px' }">
			<el-button size="mini" type="text" class="preview-close" @click="previewVisible = false">
				<i class="el-icon-close"></i>
			</el-button>
			<img :src="previewCurrentUrl" class="preview-image" />
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	const BASE_URL = 'https://ai.boningnet.cn/api'

	export default {
		name: 'MaterialAssets',
		watch: {
			'uploadForm.resourceCate'() {
				this.uploadFileList = []
				this.uploadedFileUrl = ''
			},
			activeFilter() {
				this.fetchAssets()
			}
		},
		data() {
			return {
				BASE_URL: BASE_URL,
				adminInfo: {},
				activeFilter: 'all',
				filters: [{
						label: '全部',
						value: 'all'
					},
					{
						label: '形象',
						value: 'image'
					},
					{
						label: '音频',
						value: 'audio'
					},
					{
						label: '场景',
						value: 'scene'
					},
					{
						label: '视频',
						value: 'video'
					}
				],
				activeStatus: 'all',
				statusFilters: [{
						label: '全部',
						value: 'all'
					},
					{
						label: '公开',
						value: 'public'
					},
					{
						label: '私有',
						value: 'private'
					}
				],
				selectedIds: [],
				uploadDialogVisible: false,
				uploadForm: {
					resourceName: '',
					resourceType: true,
					resourceCate: 'image',
					resourceGender: 'male',
					resourceRemark: ''
				},
				uploadFileList: [],
				uploadedFileUrl: '',
				assets: [],
				pageNum: 1,
				pageCount: 20,
				total: 0,
				loading: false,
				previewVisible: false,
				previewIndex: 0,
				previewCurrentUrl: '',
				previewPosition: {
					x: 0,
					y: 0
				}
			}
		},
		computed: {
			filteredAssets() {
				return this.assets
			},
			previewUrlList() {
				return this.filteredAssets
					.filter(asset => asset.resourceCate === 1)
					.map(asset => asset.resourceUrl)
			}
		},
		mounted() {
			const info = localStorage.getItem('adminInfo')
			if (info) {
				this.adminInfo = JSON.parse(info)
			}
			this.fetchAssets()
		},
		methods: {
			fetchAssets() {
				this.loading = true
				const params = {
					token: this.adminInfo.adminToken,
					pageNum: this.pageNum,
					pageCount: this.pageCount
				}
				if (this.activeFilter === 'image') {
					params.resourceCate = 1
				} else if (this.activeFilter === 'audio') {
					params.resourceCate = 2
				} else if (this.activeFilter === 'scene') {
					params.resourceCate = 3
				} else if (this.activeFilter === 'video') {
					params.resourceCate = 4
				}
				
				if(this.adminInfo.adminLevel>0){
					params.adminId=this.adminInfo.adminId
				}
				
				axios.get(`${BASE_URL}/resource/list`, {
					params
				}).then(res => {
					this.assets = res.data || []
					if (this.assets.length === 0) {
						this.$message.success('暂无资产数据')
						this.total = 0
					}else{
						this.total = res.data[0].allcount || 0
					}
					this.loading = false
				}).catch(() => {
					this.loading = false
					this.$message.error('获取资源列表失败')
				})
			},
			handleSizeChange(val) {
				this.pageCount = val
				this.pageNum = 1
				this.fetchAssets()
			},
			handleCurrentChange(val) {
				this.pageNum = val
				this.fetchAssets()
			},
			handleSelect(id) {
				const index = this.selectedIds.indexOf(id)
				if (index === -1) {
					this.selectedIds.push(id)
				} else {
					this.selectedIds.splice(index, 1)
				}
			},
			handlePreview(url) {
				this.previewCurrentUrl = url
				const screenWidth = window.innerWidth
				const screenHeight = window.innerHeight
				const previewWidth = 400
				const previewHeight = 500
				this.previewPosition = {
					x: (screenWidth - previewWidth) / 2,
					y: (screenHeight - previewHeight) / 2
				}
				this.previewVisible = true
			},
			handlePreviewLeave() {
				this.previewVisible = false
			},
			handleDelete(id) {
				this.$confirm('确定要删除这个素材吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios.get(`${BASE_URL}/resource/delete?token=${this.adminInfo.adminToken}&resourceId=${id}`).then(() => {
						this.selectedIds = this.selectedIds.filter(sid => sid !== id)
						this.$message.success('删除成功')
						this.fetchAssets()
					}).catch(() => {
						this.$message.error('删除失败')
					})
				})
			},
			handleBatchDelete() {
				this.$confirm(`确定要删除选中的 ${this.selectedIds.length} 个素材吗？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					const deletePromises = this.selectedIds.map(id => {
						return axios.get(`${BASE_URL}/resource/delete?token=${this.adminInfo.adminToken}&resourceId=${id}`)
					})
					Promise.all(deletePromises).then(() => {
						this.selectedIds = []
						this.$message.success('批量删除成功')
						this.fetchAssets()
					}).catch(() => {
						this.$message.error('批量删除失败')
					})
				})
			},
			getAcceptType() {
				switch (this.uploadForm.resourceCate) {
					case 'image':
					case 'scene':
						return 'image/*'
					case 'audio':
						return 'audio/*'
					case 'video':
						return 'video/*'
					default:
						return ''
				}
			},
			handleFileUploadSuccess(res) {
				this.uploadedFileUrl = res.url
			},
			handleFileChange(file, fileList) {
				if (file.status === 'ready') {
					this.uploadFileList = [file]
					const sizeInMB = (file.size / 1024 / 1024).toFixed(1)
					if (!this.uploadForm.name) {
						this.uploadForm.name = file.name
					}
					this.$set(this.uploadForm, 'size', `${sizeInMB} MB`)
				} else if (file.status === 'removed') {
					this.uploadFileList = fileList
				}
			},
			handleExceed() {
				this.$message.warning('每次仅允许上传一个素材')
			},
			handleSubmitAsset() {
				if (!this.uploadForm.resourceName) {
					this.$message.warning('请输入资产名称')
					return
				}
				if (!this.uploadFileList || !this.uploadFileList.length) {
					this.$message.warning('请选择要上传的文件')
					return
				}
				const file = this.uploadFileList[0].raw || this.uploadFileList[0]
				if (!file || !file.name) {
					this.$message.warning('请选择要上传的文件')
					return
				}
				const formData = new FormData()
				formData.append('file', file)
				axios.post(`${BASE_URL}/resource/upload?token=${this.adminInfo.adminToken}`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(res => {
					const fileUrl = res.data.data.url
					let resourceCate = 1
					if (this.uploadForm.resourceCate === 'audio') {
						resourceCate = 2
					} else if (this.uploadForm.resourceCate === 'scene') {
						resourceCate = 3
					} else if (this.uploadForm.resourceCate === 'video') {
						resourceCate = 4
					}

					let resourceGender = 1
					if (this.uploadForm.resourceGender === 'female') {
						resourceGender = 0
					} else if (this.uploadForm.resourceGender === 'other') {
						resourceGender = 2
					}

					const addData = {
						resourceName: this.uploadForm.resourceName,
						resourceType: this.uploadForm.resourceType ? 1 : 0,
						resourceCate: resourceCate,
						resourceGender: resourceGender,
						resourceUrl: fileUrl,
						resourceRemark: this.uploadForm.resourceRemark,
						adminId: this.uploadForm.resourceType ? 0 : this.adminInfo.adminId
					}
					return axios.post(`${BASE_URL}/resource/add?token=${this.adminInfo.adminToken}`, addData)
				}).then(() => {
					this.$message.success('资产上传成功')
					this.uploadDialogVisible = false
					this.fetchAssets()
					this.uploadForm = {
						resourceName: '',
						resourceType: true,
						resourceCate: 'image',
						resourceGender: 'male',
						resourceRemark: ''
					}
					this.uploadFileList = []
					this.uploadedFileUrl = ''
				}).catch(() => {
					this.$message.error('资产上传失败')
				})
			}
		}
	}
</script>

<style scoped>
	.material-assets-page {
		height: 100%;
	}

	.page-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}

	.filter-section {
		display: flex;
		align-items: center;
		gap: 24px;
	}

	.status-filter {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.filter-label {
		font-size: 14px;
		color: #666;
	}

	.status-select {
		width: 120px;
	}

	.filter-buttons {
		display: flex;
		gap: 8px;
	}

	.upload-area {
		display: flex;
		gap: 12px;
	}

	.assets-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
		gap: 9px;
	}

	.asset-card {
		background-color: #fff;
		border-radius: 8px;
		overflow: hidden;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
		cursor: pointer;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		border: 1px solid #e5e7eb;
	}

	.asset-card:hover {
		box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08), 0 6px 10px rgba(0, 0, 0, 0.06);
		transform: translateY(-4px);
		border-color: #d1d5db;
	}

	.asset-card.selected {
		border: 2px solid #4f46e5;
		box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);
	}

	.asset-preview {
		position: relative;
		width: 100%;
		aspect-ratio: 4/3;
		overflow: hidden;
	}

	.asset-preview .el-image {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	.asset-preview img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.audio-preview {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #f5f5f5;
	}

	.audio-preview audio {
		width: 90%;
		max-height: 40px;
	}

	.audio-badge {
		position: absolute;
		bottom: 8px;
		right: 8px;
		background-color: rgba(0, 0, 0, 0.7);
		color: #fff;
		font-size: 12px;
		padding: 4px 8px;
		border-radius: 4px;
	}

	.scene-badge {
		position: absolute;
		bottom: 8px;
		right: 8px;
		background-color: rgba(139, 92, 246, 0.9);
		color: #fff;
		font-size: 12px;
		padding: 4px 8px;
		border-radius: 4px;
	}

	.video-badge {
		position: absolute;
		bottom: 8px;
		right: 8px;
		background-color: rgba(239, 68, 68, 0.9);
		color: #fff;
		font-size: 12px;
		padding: 4px 8px;
		border-radius: 4px;
	}

	.video-preview {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #000;
	}

	.video-preview video {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.asset-overlay {
		position: absolute;
		top: 4px;
		right: 4px;
		display: flex;
		justify-content: flex-end;
		align-items: flex-start;
		opacity: 0;
		transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.asset-card:hover .asset-overlay {
		opacity: 1;
	}

	.asset-info {
		padding: 8px;
	}

	.asset-name {
		font-size: 12px;
		color: #333;
		margin: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.pagination-area {
		display: flex;
		justify-content: flex-end;
		margin-top: 10px;
		padding: 6px;
	}

	.batch-actions {
		position: fixed;
		bottom: 24px;
		left: 50%;
		transform: translateX(-50%);
		background-color: #fff;
		padding: 16px 24px;
		border-radius: 12px;
		box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12), 0 6px 10px rgba(0, 0, 0, 0.08);
		display: flex;
		align-items: center;
		gap: 16px;
		border: 1px solid #e5e7eb;
	}

	.batch-actions span {
		font-size: 14px;
		color: #374151;
	}

	.custom-preview {
		position: fixed;
		width: 400px;
		background-color: transparent;
		z-index: 9999;
		overflow: visible;
	}

	.preview-close {
		position: absolute;
		top: -24px;
		right: 0;
		color: #64748b;
		background-color: #fff;
		border-radius: 50%;
		width: 28px;
		height: 28px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}

	.preview-image {
		width: 100%;
		display: block;
		max-height: 500px;
		object-fit: contain;
		border-radius: 8px;
		box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15), 0 4px 10px rgba(0, 0, 0, 0.1);
	}
</style>